(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var $iZN03 = parcelRequire("iZN03");
var $b4zaZ = parcelRequire("b4zaZ");

var $4sAhZ = parcelRequire("4sAhZ");

var $ieF7G = parcelRequire("ieF7G");

var $juODO = parcelRequire("juODO");

var $jIduO = parcelRequire("jIduO");

var $fUb3f = parcelRequire("fUb3f");
const $ad9cf26ca4816d50$export$d641c58d62c1c984 = (paymentCode)=>{
    return (0, $fUb3f.default).get(`${"https://myheronapis.heron.gr/guest/checkPaymentCode"}?PaymentCode=${paymentCode}`, {
        headers: {
            "Ocp-Apim-Subscription-Key": "b0ddbdf4cda04731a709f417e10ff427"
        }
    });
};



var $3JgS8 = parcelRequire("3JgS8");

var $lVzSQ = parcelRequire("lVzSQ");

var $hSPWq = parcelRequire("hSPWq");

var $ggxi5 = parcelRequire("ggxi5");

var $lMMo8 = parcelRequire("lMMo8");
$b4zaZ.init({
    dsn: "https://388eda95ee7d478a8484b269881c5a5e@o324589.ingest.sentry.io/5853247",
    release: undefined,
    environment: "production",
    ignoreErrors: [
        "Request aborted",
        "Error: Network Error",
        "TypeError: Cancelled",
        "TypeError: Failed to fetch",
        "timeout exceeded"
    ]
});
function $c9c3af45e22cb4a1$var$invokePayment() {
    (0, $jIduO.toggleButtonLoader)(true);
    const inputsArr = [].slice.call((0, $jIduO.getInputFields)());
    (0, $jIduO.removeErrors)(inputsArr);
    const formData = inputsArr.reduce((accumulator, currentValue)=>{
        return {
            ...accumulator,
            [currentValue.id]: currentValue.value
        };
    }, {});
    if ($c9c3af45e22cb4a1$var$isGuest === false && $c9c3af45e22cb4a1$var$commodity && !(0, $ggxi5.isNullOrWhitespace)($c9c3af45e22cb4a1$var$meterId)) {
        $c9c3af45e22cb4a1$var$pay(formData);
        return;
    }
    $c9c3af45e22cb4a1$var$meterId = null;
    $c9c3af45e22cb4a1$var$commodity = null;
    (0, $ad9cf26ca4816d50$export$d641c58d62c1c984)(formData.PaymentCode).then((res)=>{
        if (res.data.Result === true) {
            $c9c3af45e22cb4a1$var$commodity = res.data.Commodity;
            $c9c3af45e22cb4a1$var$pay(formData);
            return;
        }
        (0, $jIduO.addErrorToFields)([
            "PaymentCode"
        ]);
    }).catch((error)=>{
        (0, $jIduO.toggleButtonLoader)(false);
        if (error.response?.data?.ResponseCode === 404) {
            (0, $jIduO.addErrorToFields)([
                "PaymentCode"
            ]);
            return;
        }
        (0, $jIduO.showErrorBox)();
    });
}
function $c9c3af45e22cb4a1$var$pay(formData) {
    const errorFields = (0, $juODO.validateForm)(formData);
    if (errorFields.length > 0) {
        (0, $jIduO.addErrorToFields)(errorFields);
        (0, $jIduO.toggleButtonLoader)(false);
        return;
    }
    const jsonFormData = JSON.stringify({
        ...formData,
        token: $c9c3af45e22cb4a1$var$token,
        accountId: $c9c3af45e22cb4a1$var$accountId,
        createdAt: new Date()
    });
    try {
        localStorage.setItem("myheron_payment_form_data;", jsonFormData);
    } catch (error) {
        const errorMessage = error?.message || "";
        /* catching to avoid QuotaExceeded Errors from being logged. 
    /* not setting data to local storage does not break the functionality of the page. user will just have to reenter the data on the form */ if (errorMessage.toLowerCase().indexOf("quota") === -1) $iZN03.withScope((scope)=>{
            $iZN03.captureException(error);
        });
    }
    const amount = (0, $juODO.getAmount)(formData.Amount);
    const paymentCode = document.querySelector("#PaymentCode").value;
    const trackUnconfirmedPayment = $c9c3af45e22cb4a1$var$isEna === false;
    // {cardholderName}|{amount}|{paymentCode}|{meterId}|{commodity}|{trackUnconfirmedPayment}|{invoiceNumber}
    const parameters = [
        formData?.CardholderName || " ",
        amount,
        paymentCode,
        $c9c3af45e22cb4a1$var$meterId,
        $c9c3af45e22cb4a1$var$commodity,
        trackUnconfirmedPayment,
        $c9c3af45e22cb4a1$var$invoiceNo
    ];
    try {
        if (paymentCode?.length !== 25) $iZN03.withScope((scope)=>{
            scope.setExtras({
                parameters: parameters,
                parametersDefinition: "{cardholderName}|{amount}|{paymentCode}|{meterId}|{commodity}|{trackUnconfirmedPayment}|{invoiceNumber}"
            });
            scope.setLevel("info");
            $iZN03.captureMessage("Payment page - Wrong Payment Code length in parameters");
        });
    } catch (error) {}
    try {
        if (paymentCode?.trim()?.length !== 25) $iZN03.withScope((scope)=>{
            scope.setExtras({
                parameters: parameters,
                parametersDefinition: "{cardholderName}|{amount}|{paymentCode}|{meterId}|{commodity}|{trackUnconfirmedPayment}|{invoiceNumber}"
            });
            scope.setLevel("info");
            $iZN03.captureMessage("Payment page - Wrong Payment Code length in parameters (TRIMMED)");
        });
    } catch (error) {}
    const data = {
        CurrencyCode: 978,
        BillAddrCity: formData.BillAddrCity,
        BillAddrCountry: formData.BillAddrCountry,
        BillAddrLine1: formData.BillAddrLine1,
        BillAddrPostCode: formData.BillAddrPostCode,
        BillAddrState: formData.BillAddrState,
        Email: formData.Email,
        HomePhone: (0, $juODO.getPhone)(formData.HomePhone),
        Amount: amount,
        Parameters: parameters.join("|")
    };
    if (!$c9c3af45e22cb4a1$var$commodity) {
        $iZN03.withScope((scope)=>{
            scope.setExtras({
                data: JSON.stringify($c9c3af45e22cb4a1$var$_receivedData)
            });
            scope.setLevel("info");
            $iZN03.captureMessage("Payment invocation with empty commodity prevented");
        });
        (0, $jIduO.showErrorBox)();
        (0, $jIduO.toggleButtonLoader)(false);
        return;
    }
    (0, $3JgS8.getTicket)(data).then((res)=>{
        const response = res.data;
        const merchantRef = response ? response.MerchantReference : null;
        (0, $juODO.populatePaymentKeys)(merchantRef, $c9c3af45e22cb4a1$var$commodity);
        const lang = (0, $4sAhZ.getLanguage)();
        document.querySelector("input[name=ParamBackLink]").value = `lang=${lang}`;
        document.querySelector("input[name=LanguageCode]").value = lang === "el" ? "el-GR" : "en-US";
        (0, $jIduO.showDelayAndRemoveBankRedirectionDialog)($c9c3af45e22cb4a1$var$submitForm);
        return;
    }).catch((error)=>{
        (0, $jIduO.showErrorBox)();
    }).finally(()=>{
        (0, $jIduO.toggleButtonLoader)(false);
    });
}
function $c9c3af45e22cb4a1$var$submitForm() {
    document.querySelector("#redirection_form").submit();
}
function $c9c3af45e22cb4a1$var$getBillDetails(token, accountId) {
    if (!token || token.length === 0) return;
    const storedData = (0, $lMMo8.isWebStorageSupported)() && localStorage.getItem("myheron_payment_form_data;");
    if (storedData) {
        const _formData = JSON.parse(storedData);
        if (_formData.token && _formData.token === token && (!_formData.accountId || _formData.accountId === accountId) && //use cached data for 15'
        (new Date() - new Date(_formData.createdAt)) / 1000 / 60 <= 15) {
            (0, $jIduO.fillForm)(_formData);
            (0, $jIduO.enableInputs)();
            document.getElementById("terms").checked = false;
            return;
        }
        localStorage.removeItem("myheron_payment_form_data;");
    }
    (0, $jIduO.togglePageLoader)(true);
    // if you want to use the test endpoint use
    // "api/my-bill";
    (0, $lVzSQ.getUserDetails)(token, accountId).then((res)=>{
        // Fill the form
        (0, $jIduO.fillForm)(res.data);
    }).catch((error)=>{
        if (error.response?.status === 401) // no need to log 401 unauthorized errors
        return;
    }).then(()=>{
        (0, $jIduO.togglePageLoader)(false);
        (0, $jIduO.enableInputs)();
    });
}
// Wait for client to send paymentCode: ‘’, amount: '', token: '', guest:
let $c9c3af45e22cb4a1$var$isEna = false;
let $c9c3af45e22cb4a1$var$isGuest = true;
let $c9c3af45e22cb4a1$var$token = null;
let $c9c3af45e22cb4a1$var$accountId = null;
let $c9c3af45e22cb4a1$var$meterId = null;
let $c9c3af45e22cb4a1$var$commodity = null;
let $c9c3af45e22cb4a1$var$isSettlement = false;
let $c9c3af45e22cb4a1$var$invoiceNo = null;
let $c9c3af45e22cb4a1$var$_receivedData = null;
window.addEventListener("message", (event)=>{
    if ((0, $ggxi5.isAllowedUrl)(event.origin)) {
        $c9c3af45e22cb4a1$var$_receivedData = event.data;
        if (typeof event.data.guest !== "undefined" || typeof event.data.token !== "undefined") {
            $c9c3af45e22cb4a1$var$isGuest = event.data.guest === true;
            $c9c3af45e22cb4a1$var$token = event.data.token;
            $c9c3af45e22cb4a1$var$accountId = event.data.accountId;
            $c9c3af45e22cb4a1$var$isEna = event.data.isEna === true;
            $c9c3af45e22cb4a1$var$isSettlement = event.data.fixedAmount === true;
            if ($c9c3af45e22cb4a1$var$isGuest === true) {
                document.querySelector("#PaymentCode").disabled = false;
                document.querySelector("#Amount").disabled = false;
                (0, $jIduO.enableInputs)();
                (0, $jIduO.togglePageLoader)(false);
                $c9c3af45e22cb4a1$var$meterId = null;
                $c9c3af45e22cb4a1$var$commodity = null;
            } else if ($c9c3af45e22cb4a1$var$token) {
                if (event.data.paymentCode) {
                    try {
                        if (event.data.paymentCode?.length !== 25) $iZN03.withScope((scope)=>{
                            scope.setExtras({
                                postData: JSON.stringify(event.data)
                            });
                            scope.setLevel("info");
                            $iZN03.captureMessage("Payment page - Wrong Payment Code received");
                        });
                    } catch (error) {}
                    document.querySelector("#PaymentCode").value = event.data.paymentCode;
                    document.querySelector("#PaymentCode").disabled = true;
                } else document.querySelector("#PaymentCode").disabled = false;
                if (event.data.amount) document.querySelector("#Amount").value = (0, $juODO.getAmountWithCurrency)(event.data.amount);
                if ($c9c3af45e22cb4a1$var$isEna) document.querySelector("#ena_info").style.display = "block";
                if (event.data.meterId) $c9c3af45e22cb4a1$var$meterId = event.data.meterId;
                if (event.data.invoiceNo) $c9c3af45e22cb4a1$var$invoiceNo = event.data.invoiceNo;
                document.querySelector("#Amount").disabled = event.data.fixedAmount === true;
                if (event.data.commodity) $c9c3af45e22cb4a1$var$commodity = `${event.data.commodity}` === `${(0, $hSPWq.commodities).gas}` ? (0, $hSPWq.commodities).gas : (0, $hSPWq.commodities).energy;
                else $iZN03.withScope((scope)=>{
                    scope.setExtras({
                        postData: JSON.stringify($c9c3af45e22cb4a1$var$_receivedData)
                    });
                    scope.setLevel("info");
                    $iZN03.captureMessage("Payment page - non guest payment with empty commodity");
                });
                $c9c3af45e22cb4a1$var$getBillDetails($c9c3af45e22cb4a1$var$token, $c9c3af45e22cb4a1$var$accountId);
            }
            const lang = (0, $4sAhZ.getLanguage)();
            document.querySelector('label[for="Amount"]').innerHTML = $c9c3af45e22cb4a1$var$isEna ? (0, $4sAhZ.langs)[lang].participation : (0, $4sAhZ.langs)[lang].debtAmount;
        }
    }
}, false);
window.addEventListener("load", function() {
    if (window.NodeList && !NodeList.prototype.forEach) NodeList.prototype.forEach = Array.prototype.forEach;
    (0, $4sAhZ.setLanguage)();
    (0, $ieF7G.populateStatesSelect)();
    document.querySelectorAll('input[type="text"]').forEach((x)=>{
        (0, $jIduO.handleErrorClassOnChange)(x);
    });
    // Notify the client that the form has loaded
    window.parent.postMessage("Payment gateway initialised.", "*");
    if (window.callbackHandler) window.callbackHandler.completedSuccessfully("Payment gateway initialised.");
    try {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.completedSuccessfully) window.webkit.messageHandlers.completedSuccessfully.postMessage("Payment gateway initialised.");
    } catch (error) {
        $iZN03.withScope(function(scope) {
            scope.setExtras({
                snippet: "window.webkit"
            });
            $iZN03.captureException(error);
        });
    }
    document.querySelector(".close-icon").addEventListener("click", (0, $jIduO.removeErrorBox));
    const checkbox = document.querySelector("input[type=checkbox]");
    const submit = document.querySelector("button[type=submit]");
    checkbox.addEventListener("change", function() {
        submit.disabled = !this.checked;
    });
    const form = document.getElementById("form");
    form.addEventListener("submit", function(event) {
        event.preventDefault();
        $c9c3af45e22cb4a1$var$invokePayment();
    });
});

})();
//# sourceMappingURL=index.fa7cd432.js.map
